import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import de from './translations/de.json';
import fr from './translations/fr.json';
import it from './translations/it.json';
import moment from "moment";

export const supportedLanguages = ['de', 'fr', 'it'];
export const defaultNS = 'translation'
export const resources = {
    de: {
        translation: de
    },
    fr: {
        translation: fr
    },
    it: {
        translation: it
    }
} as const;

i18n
    .use(initReactI18next)
    .init({
        defaultNS,
        resources,
        supportedLngs: supportedLanguages,
        fallbackLng: 'de',
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        }
    });

moment.locale(i18n.language);

export default i18n;